import { render, staticRenderFns } from "./Ambassadors.vue?vue&type=template&id=14162fc8&"
import script from "./Ambassadors.vue?vue&type=script&lang=js&"
export * from "./Ambassadors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports